const MIN_SAFE_AREA_APP_VERSION = [26, 9, 1]
const SAFE_AREA_ENABLED_CLASS = 'safe-area-top-enabled'

const supportsSafeArea = (appVersion: unknown): boolean => {
  if (typeof appVersion !== 'string' || !/^\d+\.\d+\.\d+$/.test(appVersion)) {
    return false
  }

  const version = appVersion.split('.').map(Number)

  if (!version.every(Number.isSafeInteger)) {
    return false
  }

  for (let index = 0; index < MIN_SAFE_AREA_APP_VERSION.length; index++) {
    if (version[index] !== MIN_SAFE_AREA_APP_VERSION[index]) {
      return version[index] > MIN_SAFE_AREA_APP_VERSION[index]
    }
  }

  return true
}

export const updateSafeAreaForAppVersion = (appVersion: unknown): void => {
  document.documentElement.classList.toggle(
    SAFE_AREA_ENABLED_CLASS,
    supportsSafeArea(appVersion),
  )
}
